import { useSite } from "@/context/SiteContext";

const LABELS = [
  { key: "jamaah", label: "Jamaah Dibina" },
  { key: "program", label: "Program Manasik" },
  { key: "pembimbing", label: "Pembimbing" },
  { key: "tahun", label: "Tahun Pengalaman" },
];

export default function Stats() {
  const { settings } = useSite();
  const stats = settings?.stats || {};

  return (
    <section className="relative -mt-14 z-10 px-4 sm:px-6 lg:px-8" data-testid="stats-section">
      <div className="mx-auto max-w-6xl rounded-3xl bg-white p-6 shadow-[0_10px_50px_rgba(15,107,79,0.12)] sm:p-10">
        <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
          {LABELS.map((item) => (
            <div key={item.key} className="text-center" data-testid={`stat-${item.key}`}>
              <p className="font-heading text-3xl font-bold text-[#0F6B4F] sm:text-4xl">{stats[item.key] || "-"}</p>
              <p className="mt-1 text-xs font-medium text-[#64748B] sm:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
